/**
 * @fileOverview Theme entry
 * @author sima.zhang
 */
var Theme = {
  default: require('./default'),
  dark: require('./dark')
};
module.exports = Theme;


//////////////////
// WEBPACK FOOTER
// ./src/theme/index.js
// module id = 167
// module chunks = 0 1 2